import type { Vault } from '@/types/vault'
import { getCategoryColor } from '@/utils/category/getCategoryColor'
import { getCategoryIcon } from '@/utils/category/getCategoryIcon'
import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'

const categoryVariants = cva('rounded-full border', {
  variants: {
    size: {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2 py-1 text-sm',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

interface Props {
  category: NonNullable<Vault['tags'][number]>
  className?: string
}

export const CategoryBadge = ({ category, className, size = 'sm' }: Props & VariantProps<typeof categoryVariants>) => {
  const color = getCategoryColor(category)
  const Icon = getCategoryIcon(category)
  const iconSize = size === 'sm' ? 12 : 16
  return (
    <div
      className={cn('flex items-center gap-1 whitespace-nowrap text-center', categoryVariants({ size }), className)}
      style={{
        borderColor: `rgba(var(${color}), 0.5)`,
        color: `rgb(var(${color}))`,
        backgroundColor: `rgba(var(${color}), 0.1)`,
      }}
    >
      <Icon size={iconSize} />
      <span>{category}</span>
    </div>
  )
}
